import { getDailySpendings } from "apis/dashboard";
import { useQuery } from "react-query";
import { ServerState } from "utils/serverState";

export const useDailySpendings = () =>
  useQuery(ServerState.DAILY_SPENDINGS, getDailySpendings);
